import { render, staticRenderFns } from "./error.vue?vue&type=template&id=7ead2132"
import script from "./error.vue?vue&type=script&lang=js"
export * from "./error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageError: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/page/PageError.vue').default,SnippetFrame: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/snippets/SnippetFrame.vue').default})
